var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccumulator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350.296 77.074-7.398-24.054c-4.047-12.855-12.62-15.553-19.109-15.553h-135.579c-6.489 0-15.062 2.698-19.109 15.542l-7.807 24.064-4.966 15.328h16.043l4.997-15.328 6.346-19.446c1.523-4.833 2.902-4.833 4.496-4.833h135.58c1.594 0 2.974 0 4.496 4.844l5.937 19.435 4.68 15.328h16.115z",
    fill: "#375e7d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m54.141 452.801h399.922l30.721-50.458v-228.746l-228.784-23.742-228.784 23.742v228.746z",
    fill: "#f9f7f8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m65.091 84.733 23.8 12.878 26.837-12.878v-21.084c0-11.623-9.491-21.114-21.113-21.114h-8.41c-11.622 0-21.113 9.491-21.113 21.114v21.084z",
    fill: "#a1d4ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m396.272 63.649v21.084l27.742 14.047 22.894-14.047v-21.084c0-11.623-9.52-21.114-21.113-21.114h-8.439c-11.593 0-21.084 9.491-21.084 21.114z",
    fill: "#f37c7c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m14.309 474.533h479.586c3.855 0 7.038-3.154 7.038-7.038v-27.071-21.931c0-8.878-7.271-16.149-16.149-16.149h-14.572c-8.877 0-16.149 7.271-16.149 16.149v14.893h-399.922v-14.893c0-8.878-7.271-16.149-16.178-16.149h-10.747-3.796c-8.877 0-16.149 7.271-16.149 16.149v21.931 27.071c0 3.884 3.154 7.038 7.038 7.038z",
    fill: "#375e7d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m245.093 317.305c6.775 0 8.615 2.219 7.067 8.586l-12.09 49.732c-2.336 9.725 2.92 6.95 8.264 0l56.623-74c5.315-6.95 6.366-10.163-2.979-10.163h-36.824c-6.512 0-7.301-1.081-5.84-7.067l12.498-51.28c3.387-13.93-2.949-6.95-8.264.029l-56.652 73.971c-5.315 6.95-6.016 10.192 3.008 10.192z",
    fill: "#ffd772",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m27.216 206.363h418.407v227.023h8.439v-14.893c0-8.878 7.271-16.149 16.149-16.149h14.572v-228.747h-42.372-415.195z",
    fill: "#e5e4ec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m478.155 440.424v27.071c0 3.884-3.154 7.038-7.038 7.038h22.778c3.855 0 7.038-3.154 7.038-7.038v-27.071-21.931c0-8.878-7.271-16.149-16.149-16.149h-14.572c-1.402 0-2.774.175-4.088.526 6.921 1.811 12.031 8.148 12.031 15.624v14.893z",
    fill: "#2b4d66",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m36.824 132.451 231.718 17.405 206.634-17.405v-23.859c0-13.112-10.746-23.859-23.858-23.859h-4.409c-110.413 0-220.797 0-331.181 0h-50.637-4.41c-13.112 0-23.858 10.747-23.858 23.859v23.859z",
    fill: "#ffd772",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m442.411 132.451h32.765v-23.859c0-13.112-10.746-23.859-23.858-23.859h-4.409-44.621c13.112 0 23.858 10.747 23.858 23.859v23.859z",
    fill: "#fbba58",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m27.216 173.597h457.567 6.629c8.264 0 15.419-4.906 18.689-11.944 1.226-2.628 1.898-5.549 1.898-8.615s-.672-5.987-1.898-8.615c-3.271-7.038-10.425-11.973-18.689-11.973h-16.236-438.352-16.266c-11.301.001-20.558 9.258-20.558 20.589 0 11.302 9.257 20.559 20.558 20.559h6.658z",
    fill: "#375e7d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m442.411 173.597h42.372 6.629c8.264 0 15.419-4.906 18.689-11.944 1.226-2.628 1.898-5.549 1.898-8.615s-.672-5.987-1.898-8.615c-3.271-7.038-10.425-11.973-18.689-11.973h-16.236-32.765c8.235 0 15.389 4.935 18.66 11.973 1.227 2.628 1.898 5.549 1.898 8.615s-.672 5.987-1.898 8.615c-3.27 7.038-10.425 11.944-18.66 11.944z",
    fill: "#2b4d66",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m93.417 84.733h22.31v-21.084c0-11.623-9.491-21.114-21.113-21.114h-8.41c-2.424 0-4.76.409-6.95 1.168 8.235 2.891 14.163 10.747 14.163 19.946z",
    fill: "#75cef8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m424.598 84.733h22.31v-21.084c0-11.623-9.52-21.114-21.113-21.114h-8.439c-2.424 0-4.76.409-6.921 1.168 8.206 2.891 14.163 10.747 14.163 19.946z",
    fill: "#e6646e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m421.532 253.075h-9.272v-9.274c0-4.233-3.431-7.664-7.664-7.664s-7.664 3.431-7.664 7.664v9.274h-9.245c-4.233 0-7.664 3.431-7.664 7.664s3.431 7.664 7.664 7.664h9.245v9.274c0 4.233 3.431 7.664 7.664 7.664s7.664-3.431 7.664-7.664v-9.274h9.272c4.233 0 7.664-3.431 7.664-7.664-.001-4.233-3.431-7.664-7.664-7.664z",
    fill: "#375e7d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m113.859 268.403h-29.173c-4.233 0-7.664-3.431-7.664-7.664s3.431-7.664 7.664-7.664h29.174c4.233 0 7.664 3.431 7.664 7.664-.001 4.232-3.432 7.664-7.665 7.664z",
    fill: "#375e7d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccumulator);
export default __webpack_public_path__ + "static/media/accumulator.0cc83d60a82f7cd97dc77c0acade9541.svg";
export { ForwardRef as ReactComponent };